
$(function () {
    $('.js-select2').each(function () {
        $(this)
            .wrap('<div class="position-relative"></div>')
            .select2({
                dropdownParent: $(this).parent(),
                minimumInputLength: 3,
                closeOnSelect: true,
                allowClear: true,
                placeholder: 'Selecione uma opção...',
                language: "pt-BR",
                width: "100%"
            });
    })
});

$(function () {
    $('.js-select2-image').each(function () {
        $(this)
            .wrap('<div class="position-relative"></div>')
            .select2({
                dropdownParent: $(this).parent(),
                closeOnSelect: true,
                allowClear: true,
                placeholder: 'Selecione uma opção...',
                language: "pt-BR",
                width: "100%",
                templateResult: formatOption,
                templateSelection: formatOption,
                minimumResultsForSearch: Infinity
            });
    })
});

function formatOption(option) {
    if (!option.id) {
        return option.text;
    }
    const myArray = option.text.split("|");
    //var imageUrl = '/site/images/products/' + option.id + '.png';
    var imageUrl = '/site/images/products/' + myArray[2].toString().trim() + '.png';
    var texto = myArray[0].toString() + " | " + myArray[1].toString();
    var optionWithImage = $(
        '<span><img src="' + imageUrl + '" class="img-flag"/> ' + texto + '</span>'
    );
    return optionWithImage;
}

$(function () {
    $('.js-select2-multiple').each(function () {
        $(this)
            .wrap('<div class="position-relative"></div>')
            .select2({
                dropdownParent: $(this).parent(),
                closeOnSelect: true,
                language: "pt-BR",
                width: "100%"
            });
    })
});

$(function () {
    $('.js-select2').next('.select2').find('.select2-selection').one('focus', select2Focus).on('blur', function () {
        $(this).one('focus', select2Focus)
    })
});

function select2Focus() {
    $(this).closest('.select2').prev('select').select2('open');
}

//$(function () {
//    $('.js-choosen').chosen({
//        disable_search_threshold: 10,
//        no_results_text: "Nenhum resultado encontrado!",
//        width: "100%"
//    })
//});

$(function () {
    $(".js-select2-ajax-cidades").each(function () {
        $(this)
            .select2({
                dropdownParent: $(this).parent(),
                placeholder: "Buscar Cidade",
                minimumInputLength: 3,
                //minimumResultsForSearch: 10,
                language: "pt-BR",
                width: "100%",
                delay: 250,
                ajax: {
                    type: 'GET',
                    dataType: 'json',
                    url: "https://portal.sfhera.net/api/Cidades/Json",
                    data: function (params) {
                        return {
                            term: params.term
                        };
                    },
                    processResults: function (data) {
                        return {
                            results: $.map(data, function (item) {
                                return {
                                    text: item.nome + ", " + item.uf,
                                    id: item.idCidade,
                                    data: item
                                }
                            })
                        };
                    }
                }
            });
    })
});
